import React from 'react';
import FileStorage from '../components/FileStorage';

const PreliminaryData = () => {
  return (
    <FileStorage
      category="preliminary-data"
      title="Preliminary Data"
      description="Research findings, initial studies, and preliminary research data"
    />
  );
};

export default PreliminaryData;